import { Component, ViewChild, OnInit, OnDestroy, ElementRef, EventEmitter, Input, HostListener, ɵɵtrustConstantResourceUrl } from '@angular/core';
import { MenuItem, LazyLoadEvent } from 'primeng/api';
import { BreadcrumbService } from '../../breadcrumb.service';
import { ActivatedRoute } from '@angular/router';
import { ReportDefinition } from '../domain/reportdefinition';
import { ReportDefinitionService } from '../service/reportdefinition.service';
import { Router } from '@angular/router';
import { AuthGuardService } from '../service/authguardservice';
import { TreeNode } from 'primeng/api';
import { Table } from 'primeng/table';
import { LookupService } from '../service/lookup.service';
import { ReportDefinitionLine } from '../domain/reportdefinitionline';
import { MessageService } from 'primeng/api';
import { IdName } from '../domain/idname';
import { LineService } from '../service/line.service';
import { AccountService } from '../service/account.service';
import { Configuration } from '../domain/configuration';
import { TreeAccountsComponent } from './tree-accounts.component';
import { FilterPickerComponent } from './filter-picker';
import * as $ from 'jquery';
import { sharedSubject } from '../view/tree-table.component';
import { Subscription } from 'rxjs';
import { CompanyService } from '../service/company.service';
import { Company } from '../domain/company';
import { TreeGridComponent  } from '@syncfusion/ej2-angular-treegrid';
import { MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DropDownButton, ItemModel } from '@syncfusion/ej2-angular-splitbuttons';
import { Utils } from 'src/app/utilities/utils';
//import { GridModule } from '@syncfusion/ej2-angular-grids';

@Component({
    templateUrl: './reportdefinition-edit.component.html',
})

export class ReportDefinitionEditComponent implements OnInit, OnDestroy {
    constructor(
        private breadcrumbService: BreadcrumbService,
        private route: ActivatedRoute,
        private reportDefinitionService: ReportDefinitionService,
        private lineService: LineService,
        private accountService: AccountService,
        private lookupService: LookupService,
        private router: Router,
        private messageService: MessageService,
        private companyService: CompanyService
    ) {



        this.items2 = [
            {
                label: 'Collapse All',
                icon: 'ui-expand-less',
                command: () => this.collapse()
            },
            {
                label: 'Expand All',
                icon: 'ui-expand-more',
                command: () => this.expand()
            }
        ];


    }

    getMenuItems(data: any): ItemModel[] {
  const items: ItemModel[] = [
    { text: 'Edit', iconCss: 'e-icons e-edit', id: 'edit' },
    { text: 'Copy', iconCss: 'e-icons e-copy', id: 'copy' }
  ];

  if (data.TotalingType?.id === 1) {
    items.push(
      { text: 'Included Accounts', iconCss: 'e-icons e-eye', id: 'included' },
      { text: 'Excluded Accounts', iconCss: 'e-icons e-circle-remove', id: 'excluded' }
    );
  }

  items.push({ text: 'Delete', iconCss: 'e-icons e-delete-1', id: 'delete' });

  return items;
}

onActionSelect(event: Event, rowData: any): void {
  const selectedValue = (event.target as HTMLSelectElement).value;
console.log(rowData);
this.selected = rowData;
  this.selectedRecordId = rowData.Id;
   this.reselectLastRow();
  switch (selectedValue) {
case 'edit':
      this.viewReportDefinitionLine(rowData);
      break;
    case 'copy':
      this.copyReportLine(rowData);
      break;
    case 'included':
      this.openSelectedLineAccounts(rowData);
      break;
    case 'excluded':

      this.openExcludedLineAccounts(rowData);
      break;
    case 'delete':
        console.log('Delete clicked for:', rowData);
      this.deleteReportDefinitionLine(rowData);
      break;
  }
  // Reset dropdown after selection (optional)
  (event.target as HTMLSelectElement).value = '';
}

onActionMenuClick(action: string, rowData: any, event: MouseEvent): void {
  event.stopPropagation();

  this.closeActionMenu();
  this.selected = rowData;
  this.selectedRecordId = rowData.Id;
  this.reselectLastRow();

  switch (action) {
    case 'edit':
      this.viewReportDefinitionLine(rowData);
      break;
    case 'copy':
      this.copyReportLine(rowData);
      break;
    case 'included':
      this.openSelectedLineAccounts(rowData);
      break;
    case 'excluded':
      this.openExcludedLineAccounts(rowData);
      break;
    case 'delete':
      this.deleteReportDefinitionLine(rowData);
      break;
  }
}

getActionItemsNew(rowData: any) {
    console.log(rowData)
  const actions = [
     { text: 'Edita', iconCss: 'e-icons e-edit', id: 'edit' },
    { text: 'Copy', iconCss: 'e-icons e-copy', id: 'copy' },
    { text: 'Delete', iconCss: 'e-icons e-delete', id: 'delete' },
  ];

  if (rowData.TotalingType === 1) {
    actions.push(
       { text: 'Included Accounts', iconCss: 'e-icons e-eye', id: 'included' },
      { text: 'Excluded Accounts', iconCss: 'e-icons e-circle-remove', id: 'excluded' }
    );
  }

  return actions;
}

    onDropdownItemClick(args: MenuEventArgs,data): void {
    console.log('Dropdown item clicked:');

        switch (args.item.id) {
    case 'edit':
      this.viewReportDefinitionLine(data);
      break;
    case 'copy':
      this.copyReportLine(data);
      break;
    case 'included':
      this.openSelectedLineAccounts(data);
      break;
    case 'excluded':

      this.openExcludedLineAccounts(data);
      break;
    case 'delete':
        console.log('Delete clicked for:', data);
      this.deleteReportDefinitionLine(data);
      break;
  }
    }  

   ngAfterViewInit(): void {
    // Bind after initial render
    this.bindDropdownEvents();
    setTimeout(() => this.updateReportLinesGridHeight(), 0);
  }

  dataBound(): void {
    // Rebind when TreeGrid updates (paging, expand/collapse, etc.)
    this.bindDropdownEvents();
    this.closeActionMenu();
     this.reselectLastRow();
     this.applyHighlightedRowState();
     this.updateReportLinesGridHeight();
  }

   selectedRecordId: number | null = null;
   openActionMenuRowId: number | null = null;
   pendingRestoreRecordId: number | null = null;
   pendingRestorePageNumber: number | null = null;
   pendingRestoreExpanded: boolean = false;
   highlightedRecordId: number | null = null;

  
  reselectLastRow(): void {
    const recordIdToRestore = this.pendingRestoreRecordId ?? this.selectedRecordId;
    if (!recordIdToRestore || !this.treeGridData?.length || !this.treeGridObj) {
      return;
    }

    this.markExpandedPath(this.treeGridData, recordIdToRestore);

    const record = this.findRecordInTree(this.treeGridData, recordIdToRestore);
    if (!record) {
      this.pendingRestoreRecordId = null;
      this.pendingRestorePageNumber = null;
      this.pendingRestoreExpanded = false;
      return;
    }

    const flatData = this.treeGridObj.flatData as any[];
    const flatIndex = flatData.findIndex(item => this.getRecordId(item) === recordIdToRestore);
    if (flatIndex < 0) {
      return;
    }

    const pageSize = this.treeGridObj.pageSettings?.pageSize || this.treeGridObj.grid?.pageSettings?.pageSize || 12;
    const targetPage = Math.floor(flatIndex / pageSize) + 1;
    const currentPage = this.treeGridObj.pageSettings?.currentPage || this.treeGridObj.grid?.pageSettings?.currentPage || 1;

    if (currentPage !== targetPage) {
      if (this.pendingRestorePageNumber !== targetPage) {
        this.pendingRestorePageNumber = targetPage;
        setTimeout(() => this.treeGridObj.goToPage(targetPage));
      }
      return;
    }

    const currentViewRecords = this.treeGridObj.getCurrentViewRecords() as any[];
    const currentPageRowIndex = currentViewRecords.findIndex(item => this.getRecordId(item) === recordIdToRestore);
    if (currentPageRowIndex < 0) {
      if (!this.pendingRestoreExpanded && this.expandParentChain(record)) {
        this.pendingRestoreExpanded = true;
        setTimeout(() => this.reselectLastRow());
      }
      return;
    }

    this.selectedRecordId = recordIdToRestore;
    this.selected = currentViewRecords[currentPageRowIndex];
    this.highlightedRecordId = recordIdToRestore;
    this.treeGridObj.clearSelection();
    this.treeGridObj.selectRow(currentPageRowIndex);

    const row = this.treeGridObj.getRows()[currentPageRowIndex];
    if (row) {
      this.applyHighlightedRowState();
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    this.pendingRestoreRecordId = null;
    this.pendingRestorePageNumber = null;
    this.pendingRestoreExpanded = false;
  }

  private findRecordById(data: any[], id: number): any | null {
    return data.find(item => item.Id === id) || null;
  }

  private findRecordInTree(records: any[], id: number): any | null {
    for (const record of records || []) {
      if (this.getRecordId(record) === id) {
        return record;
      }

      const children = record?.Childrens || [];
      const nestedRecord = this.findRecordInTree(children, id);
      if (nestedRecord) {
        return nestedRecord;
      }
    }

    return null;
  }

  private markExpandedPath(records: any[], targetId: number): boolean {
    for (const record of records || []) {
      if (this.getRecordId(record) === targetId) {
        return true;
      }

      const children = record?.Childrens || [];
      if (children.length > 0 && this.markExpandedPath(children, targetId)) {
        record.expanded = true;
        return true;
      }
    }

    return false;
  }

private bindDropdownEvents(): void {
  const dropdowns = document.querySelectorAll('[ejs-dropdownbutton]');
  dropdowns.forEach((btn: any) => {
    const instance: any = btn.ej2_instances?.[0];
    if (instance && !instance.isDestroyed) {

      // Avoid duplicate binding: remove previous handler if it exists
      if (instance._customSelectHandler) {
        instance.off('select', instance._customSelectHandler);
      }

      // Define and store a stable reference to our handler
      instance._customSelectHandler = (args: any) => {
        try {
          const tr = btn.closest('tr');
          const rowUID = tr?.getAttribute('data-uid');
          const rowData = this.treeGridObj?.grid.getRowObjectFromUID(rowUID)?.data;
          this.onDropdownItemClick(args, rowData);
        } catch (err) {
          console.error('Error in dropdown handler:', err);
        }
      };

      // Bind safely through EJ2’s built-in event system
      instance.on('select', instance._customSelectHandler);
    }
  });
}


public actionItems = [
    { text: 'Edit', iconCss: 'e-icons e-edit',id: 'edit' },
    { text: 'Duplicate',  iconCss: 'e-icons e-copy',id: 'duplicate' },
    { text: 'Included Accounts', iconCss: 'e-icons e-eye', id: 'included' },
    { text: 'Excluded Accounts', iconCss: 'e-icons e-circle-remove', id: 'excluded' },
    { text: 'Delete', iconCss: 'e-icons e-delete-1', id: 'delete' }
  ];

  private baseActions = [
    { text: 'Edit', iconCss: 'e-icons e-edit', id: 'edit' },
    { text: 'Duplicate', iconCss: 'e-icons e-copy', id: 'duplicate' },
    { text: 'Included Accounts', iconCss: 'e-icons e-eye', id: 'included' },
    { text: 'Excluded Accounts', iconCss: 'e-icons e-circle-remove', id: 'excluded' },
    { text: 'Delete', iconCss: 'e-icons e-delete-1', id: 'delete' }
  ];

 getActionItems(rowData: any) {
    // Start with basic actions
    const actions = [
      this.baseActions[0], // Edit
      this.baseActions[1], // Duplicate
      this.baseActions[4]  // Delete
    ];

    // Conditionally add the extra actions
    if (rowData.TotalingType === 1) {
      actions.splice(2, 0, this.baseActions[2], this.baseActions[3]); // insert Included/Excluded
    }

    return actions;
  }

    private subscriptionDisplayLine: Subscription;

    @ViewChild('searchTree', { static: false }) searchTree: ElementRef;

    @ViewChild('accountsLineTree', { static: false })
    accountLineTree: TreeAccountsComponent;
    @ViewChild('accountsIncludedTree', { static: false })
    accountIncludedTree: TreeAccountsComponent;
    @ViewChild('accountsExcludedTree', { static: false })
    accountExcludedTree: TreeAccountsComponent;
    @ViewChild('accountsAllTree', { static: false })
    accountAllTree: TreeAccountsComponent;
    @ViewChild('filterPicker', { static: false })
    filterPicker: FilterPickerComponent;

    id: string;
    selectedLineId: number;
    selectedLineName: string;
    reportDetailsEditMode: boolean = false;

    get reportTypeName() {
        return this.object.ReportType ? this.object.ReportType.name : null;
    }

    object: ReportDefinition = new ReportDefinition();

    objectline: ReportDefinitionLine = new ReportDefinitionLine();

    dimensions: Array<IdName[]> = [null, null, null, null];

    selectedDimension: Array<IdName> = [null, null, null, null];
    lastValidSelection: Array<IdName> = [null, null, null, null];

    cols: any[];

    tableColumns: any[];

    selected: ReportDefinitionLine = new ReportDefinitionLine();

    display: Array<boolean> = [false, false, false, false];

    displayDimTotaling: Array<boolean> = [false, false, false, false];

    displayFilter = false;
    accountsForFilterExist = false;

    accounts: TreeNode[];

    accountsAll: TreeNode[];

    accountsForFilter: TreeNode[];

    accountsAllReport: TreeNode[];

    dimensionValues: Array<Array<TreeNode>> = [null, null, null, null];

    selectedDimensionTotaling: Array<Array<TreeNode>> = [
        null,
        null,
        null,
        null
    ];

    selectedDimensionTotalingRange1: Array<TreeNode> = [null, null, null, null];
    selectedDimensionTotalingRange2: Array<TreeNode> = [null, null, null, null];

    isCustomReport: boolean;

    selectedAccountFilter: Array<TreeNode>;

    items2: any[];

    items: MenuItem[];

    reportTypes: any[];

    factTypes: any[];

    totalingTypes: any[];

    rowTypes: any[];

    formulaTypes: any[];

    accountTypes: any[];

    reportLineFormats: any[];

    currOperation: string;

    sortKey: string;

    sortField: string;

    sortOrder: number;

    displayline: boolean;

    nameMaskPattern = { 'A': { pattern: new RegExp('[a-zA-Z0-9-_]') } };

    loadingLines: boolean;
    loadingAccounts: boolean;
    loadingTreeOfAccounts: boolean;
    lastLoadLinesEvent: LazyLoadEvent; //OVO MOŽDA neće trebati, ako ne bude filtera...
    totalLinesNumber: number;
    totalAccountsNumber: number;
    totalTreeOfAccountsNumber: number;


    indexDimTotaling: Array<number> = [0, 0, 0, 0];

    timeStamp = new Date().getTime();

    urlPicture: string;

    urlPicturePost: string;


    companyId: number;

    reportLinesTable: Table;

    displayAllLineAccounts: boolean = false;

    allowUpload: boolean = false;

    displayExcludedForReportLineAccounts: boolean = false;

    displayIncludedLineAccounts = false;

    displayPictureChange = false;

    response: any;

    displayExcludedLineAccounts = false;

    canReportTypeBeChanged: boolean = false;

    displayReportAnalysisArea: boolean;

    displayCopyReportLine: boolean = false;

    reportId: number;
    reportDefinitions: ReportDefinition = new ReportDefinition();

    reports: ReportDefinition[];
    reportLine: ReportDefinitionLine;

    reportLines: any[];

    companiesAll: Company[];

    selectedCompanyId: number;

    isDisabled: boolean = false;
    isError: boolean = false;

    public treeGridData: any[] = [];  // This will be used as the dataSource for <ejs-treegrid>
    public treeGridSettings = {
        idMapping: 'Id',
        parentIdMapping: 'parentId'
    };

    public actionColumnAttributes = {
        class: 'report-actions-column'
    };

    public contextMenuItems = [
  {
    text: 'Expand All',
    target: '.e-content', // Applies to rows
    id: 'expand-row',
    iconCss: 'e-icons e-expand'
  },
  {
    text: 'Collapse All',
    target: '.e-content',
    id: 'collapse-row',
    iconCss: 'e-icons e-collapse-2'
  }
];

     renderDropDown = false;


      // @ViewChild('treeGridObj', { static: false })treeGridObj!: TreeGridComponent;

    @ViewChild('treeGridObj') treeGridObj!: TreeGridComponent;
    @ViewChild('reportLinesGridContainer', { static: false }) reportLinesGridContainer?: ElementRef<HTMLElement>;
    public reportLinesGridHeight = 500;

onDataBound() {
    console.log('TreeGrid data bound, rows:', this.treeGridData.length);
  }
  @HostListener('document:click')
closeAllDropdowns() {
  this.closeActionMenu();
}

@HostListener('window:resize')
onWindowResize(): void {
  this.updateReportLinesGridHeight();
}

private queueRowRestore(recordId: number | null): void {
  this.pendingRestoreRecordId = recordId;
  this.pendingRestorePageNumber = null;
  this.pendingRestoreExpanded = false;
  this.highlightedRecordId = recordId;
  if (recordId != null) {
    this.selectedRecordId = recordId;
  }
}

private applyHighlightedRowState(): void {
  if (!this.treeGridObj) {
    return;
  }

  const rows = this.treeGridObj.getRows() as HTMLElement[];
  const currentViewRecords = this.treeGridObj.getCurrentViewRecords() as any[];

  rows.forEach((row, index) => {
    const record = currentViewRecords[index];
    const isHighlighted = this.highlightedRecordId != null && this.getRecordId(record) === this.highlightedRecordId;

    row.classList.toggle('restored-selected-row', isHighlighted);
    row
      .querySelectorAll('.e-rowcell, .e-detailrowcollapse, .e-detailrowexpand, .e-rowdragdrop')
      .forEach(cell => cell.classList.toggle('restored-selected-cell', isHighlighted));
  });
}

private updateReportLinesGridHeight(): void {
  const containerTop = this.reportLinesGridContainer?.nativeElement.getBoundingClientRect().top;

  if (containerTop == null) {
    return;
  }

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  const maxAvailableHeight = Math.max(260, viewportHeight - containerTop - 224);
  const rowCount = this.getVisibleTreeRowCount();
  const normalizedRowCount = rowCount < 10 ? 10 : rowCount;
  const contentHeight = 120 + (Math.max(normalizedRowCount, 1) * 38) + (normalizedRowCount > 200 ? 48 : 0);
  const preferredFillHeight = Math.round(maxAvailableHeight * 0.665) + 12;

  this.reportLinesGridHeight = Math.max(260, Math.min(maxAvailableHeight, Math.max(contentHeight, preferredFillHeight)));
}

private getVisibleTreeRowCount(): number {
  const currentViewRecords = this.treeGridObj?.getCurrentViewRecords?.() as any[] | undefined;

  if (currentViewRecords?.length) {
    return currentViewRecords.length;
  }

  return this.treeGridData?.length ?? 0;
}

private expandParentChain(record: any): boolean {
  if (!record || !this.treeGridObj?.flatData?.length) {
    return false;
  }

  const flatData = this.treeGridObj.flatData as any[];
  const parentRecords: any[] = [];
  let currentParentId = this.getParentId(record);

  while (currentParentId != null) {
    const parentRecord = this.findRecordById(flatData, currentParentId);
    if (!parentRecord) {
      break;
    }

    parentRecords.unshift(parentRecord);
    currentParentId = this.getParentId(parentRecord);
  }

  let expandedAny = false;
  for (const parentRecord of parentRecords) {
    if (parentRecord?.expanded !== true) {
      expandedAny = true;
      try {
        (this.treeGridObj as any).expandRow(null, parentRecord);
      } catch {
        parentRecord.expanded = true;
      }
    }
  }

  return expandedAny;
}

closeActionMenu(): void {
  this.openActionMenuRowId = null;
  this.treeGridData?.forEach(row => row._dropdownOpen = false);
}

isActionMenuOpen(data: any): boolean {
  return this.openActionMenuRowId === data?.Id;
}

    openAllLineAccounts() {
        this.displayAllLineAccounts = true;
    }

    openExcludedLineAccounts(line) {
        const lineId = this.getRecordId(line);
        const selectedLine = this.object.lines?.find(l => this.getRecordId(l) === lineId) || line;
        this.selected = selectedLine;

        var highlightedIds = [];
        var highlightedRangeIds = [];

        (selectedLine?.Totaling || []).forEach(totaling => {
            if (totaling.Names.includes("..")) {
                //it's a range
                var rangeIds = [];
                totaling.Ids.split("..").forEach(id => {
                    rangeIds.push(Number(id))
                })

                //range start - rangeIds[0], range end - rangeIds[1];
                highlightedRangeIds.push(rangeIds);
            } else {
                //it's not a range
                totaling.Ids.split("|").forEach(id => {
                    highlightedIds.push(Number(id));
                })
            }
        });

        this.displayExcludedLineAccounts = true;
    }

    openExcludedReportAccounts() {
        this.selected = null;
        this.displayExcludedForReportLineAccounts = true;
    }

    openSelectedLineAccounts(line) {
        this.selected = line;
        this.displayIncludedLineAccounts = true;
    }


    openPictureChange() {
        this.displayPictureChange = true;
        var pictureLink = this.getLinkPicture();
        this.GetImage(pictureLink);
    }

    checkIfReportTypeCanBeChanged() {
        if (this.id === 'new') {
            this.canReportTypeBeChanged = true;
        }
        else {
            if (!this.object.lines || this.object.lines.length == 0) {
                this.canReportTypeBeChanged = true;
            }
            else {
                this.canReportTypeBeChanged = false;
            }
        }
    }

    ngOnInit() {

        // console.log('Dropdown items:', this.dropdownItems);

        this.companyService.get().then(objects => this.companiesAll = objects);

        this.subscriptionDisplayLine = sharedSubject.subscribe(() => {
            this.displayline = true;
        });

        this.displayReportAnalysisArea = false;
        /*
         if (!localStorage.getItem('foo')) { 
             localStorage.setItem('foo', 'no reload') 
             location.reload() 
           } else {
             localStorage.removeItem('foo') 
           }
         */
        this.id = this.route.snapshot.paramMap.get('id');
        this.companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
        console.log(localStorage.getItem('currentCompany'));

        this.loadingLines = true;
        this.loadingAccounts = true;
        if (this.id === 'new') {
            this.object = new ReportDefinition();
            this.object.CompanyId = JSON.parse(
                localStorage.getItem('currentCompany')
            ).id;
            this.checkIfReportTypeCanBeChanged();
        }
        else {
            this.reportDefinitionService
                .getById(parseInt(this.id))
                .then(def => {
                    this.object = def;
                    this.isCustomReport = (this.object.ReportType.id === 2) ? true : false;

                    this.lookupService.getIdName('totalingTypes').then(objects => {
                        if (this.isCustomReport) {
                            objects.splice(objects.findIndex(o => o.id === 1), 1);
                        }
                        this.totalingTypes = objects;
                    });
                })
                .then(def => {
                    this.breadcrumbService.setItems([
                        {
                            label: 'Report Definitions',
                            routerLink: ['/reportdefinitions']
                        },
                        {
                            label: this.object.Name,
                            routerLink: ['/reportdefinitions/' + this.id]
                        }
                    ]);
                })
                .then(def => {
                    this.lineService.count(this.object.Id).subscribe(
                        data => {
                            this.totalLinesNumber = data;
                            if (data > 0) {
                                this.lineService
                                    .getForTreeGrid(
                                        this.object.Id,
                                        0,
                                        this.totalLinesNumber,
                                        'LineNo',
                                        true,
                                        null
                                    )
                                    .then(objects => {
                                        this.loadingLines = false;
                                        if (this.pendingRestoreRecordId) {
                                            this.markExpandedPath(objects, this.pendingRestoreRecordId);
                                        }
                                        this.object.lines = objects;
                                        //console.log("this.object.lines")
                                        //console.log(this.object.lines);
                                        this.treeGridData = this.object.lines;
                                        /* this.treeGridData = this.object.lines.map(item => ({
                                            ...item,
                                            parentId: item.ParentLine?.id || null // Important!
                                        }));*/
                                        //console.log("this.treeGridData")
                                        //console.log(this.treeGridData);
                                        
                                        this.checkIfReportTypeCanBeChanged();
                                    });
                            } else {
                                this.loadingLines = false;
                                this.object.lines = [];
                                this.treeGridData = [];
                                this.checkIfReportTypeCanBeChanged();
                            }
                        },
                        error => {
                            this.loadingLines = false;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error retrieving number of lines',
                                detail: error
                            });
                        }
                    );
                });
        }



        this.lookupService.getIdName('reportTypes').then(objects => {
            this.reportTypes = objects;
        });

        this.lookupService.getIdName('factTypes').then(objects => {
            this.factTypes = objects;
        });

        this.lookupService.getIdName('formulaTypes').then(objects => {
            this.formulaTypes = objects;
        });

        this.lookupService.getIdName('accountTypes').then(objects => {
            this.accountTypes = objects;
        });

        this.lookupService.getIdName('reportLineFormats').then(objects => {
            this.reportLineFormats = objects;
            console.log()
        });

        this.lookupService.getIdName('rowTypes').then(objects => {
            this.rowTypes = objects;
        });

/*         this.accountService
        .getAll(
            this.object.Id
        )
        .then(objects => {
            this.reportLines = objects;
        }); */


        if (this.id !== 'new') {
            this.accountService.count().subscribe(
                data => {
                    this.totalAccountsNumber = data;
                    this.totalTreeOfAccountsNumber = data;
                    this.accountService
                        .getAll(this.id, this.object.Filter)
                        .then(objects => (this.accountsAll = objects));
                },
                error => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error retrieving the account number',
                        detail: error
                    });
                }
            );
        }

        this.cols = [
            { field: 'RowNo', header: 'Row no.' },
            { field: 'Description', header: 'Description' },
            {
                field: 'TotalingType',
                subfield: 'name',
                header: 'Totaling type'
            },
            { field: 'ShowOppositeSign', header: 'Show Opposite Sign' },
            { field: 'AccountType', subfield: 'name', header: 'Account Type' }
        ];

        this.tableColumns = [{ field: 'code', header: 'Code', width: '20%' }, { field: 'name', header: 'Name', width: '80%' }];

        this.items = [
            // {
            //     label: 'Move Up 10 Lines',
            //     icon: 'pi pi-angle-double-up',
            //     command: () => this.moveUp(this.object.lines, this.selected, 10)
            // },
            {
                label: 'Move Up',
                icon: 'pi pi-arrow-up',
                command: () => this.moveUp(this.object.lines, this.selected)
            },
            {
                label: 'Move Down',
                icon: 'pi pi-arrow-down',
                command: () =>
                    this.moveDown(this.object.lines, this.selected)
            }
            // {
            //     label: 'Move Down 10 Lines',
            //     icon: 'pi pi-angle-double-down',
            //     command: () =>
            //         this.moveDown(this.object.lines, this.selected, 10)
            // },
            //{
            //    label: 'Duplicate',
            //   icon: 'ui-icon-content-copy',
            //   command: () => this.duplicateClick()
            // }
        ];

        this.urlPicturePost = Configuration.server + '/api/report/' + this.id;
        this.urlPicture =
            Configuration.server + '/api/report/' + this.id + '/image';

 
    }

    ngOnDestroy(): void {
        this.subscriptionDisplayLine.unsubscribe();
    }

    editReport() {
        this.reportDetailsEditMode = true;

        if (this.object.ReportType.name === 'GEN') {
            this.displayReportAnalysisArea = true
        } else {
            this.displayReportAnalysisArea = false
        }
    }

    saveEditReport() {
        this.saveClick(null);

    }

    cancelEditReport() {
        this.reportDetailsEditMode = false;
        this.ngOnInit();
    }

    previewReport() {
        var openLink = !(this.object.ReportPreviewLink.startsWith("http")) ? "http://" + this.object.ReportPreviewLink : this.object.ReportPreviewLink;

        var win = window.open(openLink, '_blank');
        win.focus();
    }

onCellDoubleClick(event: any) {
    console.log('rowDoubleClick event triggered:', event);
    if (event && event.rowData) {
        const rowData = event.rowData;
        console.log('Row Data:', rowData);
        this.viewReportDefinitionLine(rowData);
    } else {
        console.error('Row data is undefined or event is invalid:', event);
    }
}


    viewReportDefinitionLine(reportDefinitionLine: ReportDefinitionLine) {

        /*  
         const rptLine = sessionStorage.getItem('rptLine');
     let parsedLine = null;
 
     if (rptLine) {
         try {
             console.error("parsedLine");
             parsedLine = JSON.parse(rptLine);
         } catch (e) {
             console.error("Failed to parse rptLine from sessionStorage", e);
         }
     } */

        // Determine the correct objectline
        this.objectline = reportDefinitionLine; //parsedLine || 
        console.log(this.objectline)
        this.currOperation = 'edit';
        this.displayline = true;
        // ovdje dovuci podatke
        this.lineService
            .getAllForReport(
                this.object.Id,
                reportDefinitionLine.Id
            )
            .then(objects => {
                this.reportLines = objects;
            });

    }

    cancelLineChanges() {
        this.displayline = false;
        sessionStorage.setItem('rptLine', "0");
    }

    viewSelectedLineAccounts(reportDefinitionLine: ReportDefinitionLine) {
        this.objectline = reportDefinitionLine;
        this.accountLineTree.lineId = reportDefinitionLine.Id;
        this.accountLineTree.refresh();
        this.displayIncludedLineAccounts = true;
    }

    copyReportLine(reportDefinitionLine: ReportDefinitionLine) {
        this.displayCopyReportLine = true;
        this.reportLine = reportDefinitionLine;

        this.reportDefinitionService
            .get(parseInt(JSON.parse(localStorage.getItem('currentCompany')).id))
            .then(def => {
                console.log("def")
                console.log(def);
                this.reports = def;

            })

    }

    copyToReportClick() {
        this.displayCopyReportLine = true;
        this.isDisabled = true;
        console.log(this.reportLine);
        if (confirm(`Are you sure you want to copy report line "${this.reportLine.RowNo}"-"${this.reportLine.Description}"?`)) {

            this.lineService
                .copy(this.reportLine.Id, this.reportId, this.selectedCompanyId)
                /* .then(def => {
                     this.messageService.add({
                         severity: 'info',
                         summary: 'Report definition line created',
                         detail: "Successfully created"
 
                     });
                 })*/
                .then(data => {
                    this.isDisabled = false;
                })
                .catch(error => {
                    this.isDisabled = false;
                });
        }
        else {
            alert("Copy action cancelled.")
        }


    }

    deleteReportDefinitionLine(reportDefinitionLine: ReportDefinitionLine) {
        if (confirm(`Are you sure you want to delete report line "${reportDefinitionLine.LineNo}"?`)) {
            this.lineService.delete(reportDefinitionLine.Id).then(def => {
                this.currOperation = 'delete';
                this.selectedRecordId = null;
                this.closeActionMenu();
                this.messageService.add({
                    severity: 'info',
                    summary: 'Report definition line deleted',
                    detail:
                        reportDefinitionLine.Id +
                        ' - ' +
                        reportDefinitionLine.LineNo
                });
                this.checkIfReportTypeCanBeChanged();
                console.log("Refreshing after delete");
                this.ngOnInit();
            }).catch(() => {
                this.closeActionMenu();
            });
        }
        else {
            alert("Delete action cancelled.")
        }
    }

    companyChanged(newObj) {
        this.selectedCompanyId = newObj.value.id;
        this.reportDefinitionService
            .get(this.selectedCompanyId)
            .then(def => {
                this.reports = def;
            })

    }

    dataChanged(newObj) {
        this.reportId = newObj.value.Id;
        console.log(this.reportId)
    }

    saveClick($event) {
        this.isDisabled = true;
        if (this.objectline.Constant != null) {
            this.objectline.Constant = this.objectline.Constant.replace(",", ".");
        }

        if (!this.object.ReportType) {
            this.messageService.add({
                severity: 'error',
                summary: 'Can not save report definition',
                detail: 'Report type is required!'
            });
            this.isDisabled = false;
            return;
            
        }

        if (!this.object.Name) {
            this.messageService.add({
                severity: 'error',
                summary: 'Can not save report definition',
                detail: 'Code is required!'
            });
            this.isDisabled = false;
            return;
        }

        if (!this.object.Description) {
            this.object.Description = "";
        }

        if (!this.object.ReportPreviewLink) {
            this.object.ReportPreviewLink = '';
        }

        const dims = new Array<string>();

        if (this.object.Dimension1) {
            dims.push(this.object.Dimension1);
        }
        if (this.object.Dimension2) {
            dims.push(this.object.Dimension2);
        }
        if (this.object.Dimension3) {
            dims.push(this.object.Dimension3);
        }
        if (this.object.Dimension4) {
            dims.push(this.object.Dimension4);
        }
        const findDuplicates = arr =>
            arr.filter((item, index) => arr.indexOf(item) != index);

        if (findDuplicates(dims).length !== 0) {
            this.messageService.add({
                severity: 'error',
                summary: 'Can not save report definition',
                detail: 'Dimensions must be unique!'
            });
            this.isDisabled = false;
            return;
        }

        if (this.id === 'new') {

            this.reportDefinitionService
                .post(this.object)
                .then(def => this.router.navigate(['/reportdefinitions/' + def.Id]))
                .then(data => {
                    this.isDisabled = false;
                    this.ngOnInit()
                })
                .catch(error => {
                    this.isDisabled = false;
                    this.ngOnInit()
                });

        } else {
            console.log("3")
            this.reportDefinitionService
                .put(this.object, this.id)
                .then(def => this.router.navigate(['/reportdefinitions/' + this.id])) //TO DO - provjeri trebamo li refresh na save TREBA!
                .then(data => {
                    this.isDisabled = false;
                    this.ngOnInit()
                })
                .catch(error => {
                    this.isDisabled = false;
                    this.ngOnInit()
                });
        }
    }

    saveCloseClick($event) {
        if (this.objectline.Constant != null) {
            this.objectline.Constant = this.objectline.Constant.replace(",", ".");
        }
        const dims = new Array<string>();

        if (this.object.Dimension1) {
            dims.push(this.object.Dimension1);
        }
        if (this.object.Dimension2) {
            dims.push(this.object.Dimension2);
        }
        if (this.object.Dimension3) {
            dims.push(this.object.Dimension3);
        }
        if (this.object.Dimension4) {
            dims.push(this.object.Dimension4);
        }
        const findDuplicates = arr =>
            arr.filter((item, index) => arr.indexOf(item) != index);

        if (findDuplicates(dims).length !== 0) {
            this.messageService.add({
                severity: 'error',
                summary: 'Can not save report definition',
                detail: 'Dimensions must be unique!'
            });
            this.isDisabled = false;
            return;
        }

        if (this.id === 'new') {
            this.reportDefinitionService
                .post(this.object)
                .then(def => this.router.navigate(['/reportdefinitions']));
        } else {
            this.reportDefinitionService
                .put(this.object, this.id)
                .then(def => this.router.navigate(['/reportdefinitions']));
        }
    }



    cancelClick($event) {
        this.router.navigate(['/reportdefinitions']);
    }

    addClick() {
        this.lineService
        .getAllForReport(
            this.object.Id,
            0
        )
        .then(objects => {
            this.reportLines = objects;
        });
        this.objectline = new ReportDefinitionLine();
        this.objectline.AccountType = this.accountTypes[0];
        this.objectline.RowType = this.rowTypes.find(t => t.id == 3);
        this.objectline.ShowValues = true;
        this.objectline.ParentLine = new ReportDefinitionLine();
        this.objectline.ShowOppositeSign = false;

        this.displayline = true;
        this.currOperation = 'new';
    }

    duplicateClick() {
        const clone = this.deepCopy(this.selected) as ReportDefinitionLine;

        clone.RowNo = '';
        clone.Id = 0;

        this.objectline = clone;

        this.displayline = true;
        this.currOperation = 'new';
    }

    deepCopy(obj) {
        var copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || 'object' != typeof obj) {
            return obj;
        }

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    copy[attr] = this.deepCopy(obj[attr]);
                }
            }
            return copy;
        }

        throw new Error('Unable to copy obj! Its type isn\'t supported.');
    }

    onSortChange(event) {
        const value = event.value;

        if (value.indexOf('!') === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

    openFilterPicker() {

        this.accountService.getAll(this.id, []).then(data => {
            this.accountsAll = data;

            this.accountsForFilter = this.accountsAll;

            this.object.Filter.forEach(account => {
                this.accountsForFilter.splice(
                    this.accountsForFilter.findIndex(
                        value =>
                            value.data.id ===
                            account.id
                    ),
                    1
                );
            });

            if (this.accountsForFilter && this.accountsForFilter.length > 0) {
                this.accountsForFilterExist = true;
            }
            else {
                this.accountsForFilterExist = false;
            }

            this.accountsForFilterExist = true;

            this.displayFilter = true;
            this.selectedAccountFilter = [];
            this.object.Filter
        });
    }

    okClickReportFilter() {
        if (this.object.Filter === undefined) {
            this.object.Filter = Array<IdName>();
        }

        this.selectedAccountFilter.forEach(element => {
            let chip = new IdName();
            chip.id = element.data.id;
            chip.name = element.data.code;
            chip.desc = element.data.name;
            this.object.Filter.push(chip);
        });

        this.displayFilter = false;

        this.refreshTrees();
    }

    updateFilterAccounts($event) {
        this.object.Filter = $event;
    }

    saveClickLine(close = false) {
        this.isDisabled = true;
        if (this.objectline.Formula != null) {

            if (this.objectline.Formula.name.includes("*") || this.objectline.Formula.name.includes("/")) {
               
               this.isError=false;
                if (this.objectline.A != null) {
                    if (this.objectline.A.length >1){
                        this.isError=true;
                    }
                    this.objectline.A.splice(1);
                }
                if (this.objectline.B != null) {
                    if (this.objectline.B.length >1){
                        this.isError=true;
                    }
                    this.objectline.B.splice(1);
                }
                if (this.objectline.C != null) {
                    if (this.objectline.C.length >1){
                        this.isError=true;
                    }
                    this.objectline.C.splice(1);
                }
                if (this.objectline.D != null) {
                    if (this.objectline.D.length >1){
                        this.isError=true;
                    }
                    this.objectline.D.splice(1);
                }

                if(this.isError){
                    this.messageService.add({
                        severity: "error",
                        summary: 'Saving Totaling',
                        detail: 'For formula types including multiplication or division, formula parts must not contain more than one report line!'
                    });
                }


            }
        }

        if (this.objectline.Constant != null) {
            var constanta = this.objectline.Constant.toString();
            this.objectline.Constant = constanta.replace(",", ".");
        }

        if (!this.objectline.TotalingType) {
            this.messageService.add({
                severity: 'error',
                summary: 'Can not save report definition line',
                detail: 'Account type is must have!'
            });
            this.isDisabled = false;
            return;
        }

        if (this.objectline.Description == null) {
            this.objectline.Description = "";
        }

        if (this.currOperation === 'new') {
            if (
                this.object.lines &&
                this.object.lines.filter(
                    e => e.RowNo === this.objectline.RowNo
                ).length > 0
            ) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Can not save report definition line',
                    detail: 'Row No. must be unique!'
                });
                this.isDisabled = false;
                return;
            }
        } else if (this.currOperation === 'edit') {
            if (
                this.object.lines &&
                this.object.lines.filter(
                    e => e.RowNo === this.objectline.RowNo
                ).length > 1
            ) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Can not save report definition line',
                    detail: 'Row No. must be unique!'
                });
                this.isDisabled = false;
                return;
            }
        }

        // tslint:disable-next-line: radix
        this.objectline.ReportId = parseInt(this.id);

        let promise;
        if (this.currOperation === 'new') {
            if (
                this.object.lines &&
                this.object.lines[this.object.lines.length - 1]
            ) {
                this.objectline.LineNo =
                    this.object.lines[this.object.lines.length - 1].LineNo + 1;
            } else {
                this.objectline.LineNo = 1;
            }
            promise = this.lineService.post(this.objectline);
        } else {
            promise = this.lineService.put(this.objectline);
        }

        //delete possible saved values inside hidden fields
        if (this.objectline.TotalingType) {
            if (this.objectline.TotalingType.id == 1) {
                //account totaling
                this.objectline.Constant = null;
                this.objectline.A = null;
                this.objectline.ARep = null;
                this.objectline.B = null;
                this.objectline.BRep = null;
                this.objectline.C = null;
                this.objectline.CRep = null;
                this.objectline.D = null;
                this.objectline.DRep = null;
                this.objectline.Formula = null;
            } else if (this.objectline.TotalingType.id == 3) {
                //formula totaling
                this.objectline.Constant = null;
                this.objectline.Totaling = [];
            } else if (this.objectline.TotalingType.id == 4) {
                //constant totaling
                this.objectline.A = null;
                this.objectline.ARep = null;
                this.objectline.B = null;
                this.objectline.BRep = null;
                this.objectline.C = null;
                this.objectline.CRep = null;
                this.objectline.D = null;
                this.objectline.DRep = null;
                this.objectline.Formula = null;
                this.objectline.Totaling = [];
            } else {
                //percentage totaling
                this.objectline.Constant = null;
                this.objectline.A = null;
                this.objectline.ARep = null;
                this.objectline.B = null;
                this.objectline.BRep = null;
                this.objectline.C = null;
                this.objectline.CRep = null;
                this.objectline.D = null;
                this.objectline.DRep = null;
                this.objectline.Formula = null;
                this.objectline.Totaling = [];
            }
        }


        promise.then(data => {

            if (this.currOperation === 'new') {
                if (this.object.lines === undefined) {
                    this.object.lines = new Array<ReportDefinitionLine>();
                }

                const createdLineId = data?.Id ?? null;
                this.queueRowRestore(createdLineId);

                if (close) {
                    this.displayline = false;
                    this.refreshTrees();
                    this.checkIfReportTypeCanBeChanged();
                    this.ngOnInit();
                }
                else {
                    this.refreshTrees();
                    this.ngOnInit();

                    if (createdLineId != null) {
                        this.lineService.getById(createdLineId)
                            .then(line => {
                                this.selectedRecordId = line.Id;
                                this.selected = line;
                                this.viewReportDefinitionLine(line);
                            });
                    }
                }
            } else if (this.currOperation === 'edit') {
                this.queueRowRestore(this.objectline.Id);

                const itemIndex = this.object.lines.findIndex(
                    item => item.Id === this.objectline.Id
                );
                this.object.lines[itemIndex] = this.objectline;

                if (close) {

                    this.displayline = false;
                    this.refreshTrees();
                    this.checkIfReportTypeCanBeChanged();
                    this.ngOnInit();
                }
                else {

                    this.refreshTrees();
                    this.ngOnInit();
                }
            }

        })
            .then(data => {
                this.isDisabled = false;
                if (this.objectline.Id != null) {
                    this.lineService.getById(this.objectline.Id)
                        .then(line => {
                            this.objectline = line;
                            this.selectedRecordId = line.Id;
                            this.selected = line;
                        });
                }
            })
            .catch(error => {
                this.isDisabled = false;
                if (this.objectline.Id != null) {
                    this.lineService.getById(this.objectline.Id)
                        .then(line => {
                            this.objectline = line;
                            this.selectedRecordId = line.Id;
                            this.selected = line;
                        });
                }
            })

    }

    refreshTrees() {
        if (this.accountAllTree)
            this.accountAllTree.filter = this.object.Filter;
        else return; //TO DO: Srediti, vidjeti treba li ova metoda uopće
        this.accountIncludedTree.filter = this.object.Filter;
        this.accountExcludedTree.filter = this.object.Filter;
        this.accountLineTree.filter = this.object.Filter;

        this.accountAllTree.refresh();
        this.accountIncludedTree.refresh();
        this.accountExcludedTree.refresh();
        this.accountLineTree.refresh();
    }



    moveUp(array, element, lines = 1) {
        const index = array.indexOf(element);
        if (index > 0) {
            this.loadingLines = true;
            this.lineService
                .swapLineNoFor(array[index - 1].Id, array[index].Id)
                .then(_ => {
                    array.splice(index - 1, 2, array[index], array[index - 1]);
                    this.swapLineNo(array, index - 1, index);
                    this.loadingLines = false;
                });
        }
    }

    moveDown(array, element, lines = 1) {
        const index = array.indexOf(element);
        if (index < array.length - 1) {
            this.loadingLines = true;
            this.lineService
                .swapLineNoFor(array[index + 1].Id, array[index].Id)
                .then(_ => {
                    array.splice(index, 2, array[index + 1], array[index]);
                    this.swapLineNo(array, index, index + 1);
                    this.loadingLines = false;
                });
        }
    }

    swapLineNo(array, index1, index2) {
        const temp = array[index1].LineNo;
        array[index1].LineNo = array[index2].LineNo;
        array[index2].LineNo = temp;
    }

    filter(names: IdName[], array: any[]) {
        if (!array) {
            return [];
        }
        if (!names) {
            return [];
        }

        return array.reduce((r, { children = [], ...o }) => {
            if (names.filter(e => e.name === o.data.name).length > 0) {
                r.push(o);
                return r;
            }
            children = this.filter(names, children);
            if (children.length) {
                r.push(Object.assign(o, { children }));
            }
            return r;
        }, []);
    }

    colorize(array: any[], lines: IdName[], report: IdName[]) {
        if (!array || !lines || !report) {
            return;
        }

        for (let i = 0; i < array.length; i++) {
            const o = array[i];
            if (
                lines.findIndex(e => e.name === o.data.name) > -1 &&
                report.findIndex(e => e.name === o.data.name) > -1
            ) {
                o.data.name = o.data.name + '(RL)';
            } else if (lines.findIndex(e => e.name === o.data.name) > -1) {
                o.data.name = o.data.name + '(L)';
            } else if (report.findIndex(e => e.name === o.data.name) > -1) {
                o.data.name = o.data.name + '(R)';
            }
        }

        for (let i = 0; i < array.length; i++) {
            const o = array[i];

            if (o.children) {
                this.colorize(o.children, lines, report);
            }
        }

        return;
    }

    onLineRowSelectChanged(line: any) {
        // this.objectline = line.data;
        // this.accountLineTree.lineId = line.data.LineNo;
        // this.accountLineTree.refresh();
        //this.onFilterReportChanged(null);
    }
    onFilterReportChanged($event) {
        this.lookupService.getHierarchy('accounts').then(objects => {
            this.accountsAll = objects;
            // this.colorize(
            //     this.accountsAll,
            //     this.accountsLine(),
            //     this.object.Filter
            // );
        });
    }
    onTypeReportChange($event) {

        if ($event.value.name === 'GEN') {
            this.displayReportAnalysisArea = true
        } else {
            this.displayReportAnalysisArea = false
        }

    }



    accountsLine() {
        const retval = new Array<IdName>();
        if (this.objectline) {
            // this.lookupService.extractTotalings(this.objectline.Totaling).then(objects => {
            //     objects.forEach( se => retval.push(se) );
            // });
            return retval;
        } else {
            return new Array<IdName>();
        }
    }

    accountsReport() {
        const retval = new Array<IdName>();
        // if (this.object.lines) {
        //     this.object.lines.forEach(e => {
        //         this.lookupService.extractTotalings(e.Totaling).then(objects => {
        //             objects.forEach( se => retval.push(se) );
        //         });
        //     });
        // }
        return retval;
    }

    lazyloadLines(event: LazyLoadEvent) {
        if (this.id !== 'new') {
            this.lastLoadLinesEvent = event;
            this.loadingLines = true;

            this.lineService
                .get(
                    parseInt(this.id),
                    event.first,
                    event.rows,
                    event.sortField,
                    event.sortOrder == 1,
                    this.filter
                )
                .then(data => {
                    this.object.lines = data;
                    this.loadingLines = false;
                });
        }
    }

    filterAccountsRemove() {
        this.refreshTrees();
    }

    lazyloadAccounts(event: LazyLoadEvent) {
        if (this.id !== 'new') {
            this.loadingAccounts = true;

            this.accountService
                .getAll(this.id, this.object.Filter)
                .then(data => {
                    this.accountsAllReport = data;
                    this.loadingAccounts = false;
                });
        }
    }

    onAccountExpand(event) {
        const node = event.node;

        if (this.id !== 'new' && node.children == undefined) {
            this.loadingAccounts = true;

            this.accountService.children(this.id, node.data.id).then(data => {
                node.children = [...data];
                this.accountsAllReport = [...this.accountsAllReport];
                this.loadingAccounts = false;
            });
        }
    }

    lazyloadTreeOfAccounts(event: LazyLoadEvent) {
        if (this.id !== 'new') {
            this.loadingTreeOfAccounts = true;

            this.accountService.getAll(this.id, []).then(data => {
                this.accountsAll = data;
                this.loadingTreeOfAccounts = false;
            });
        }
    }

    filterTreeOfAccounts(value: any) {
        this.loadingTreeOfAccounts = true;

        this.accountService.search(value).then(data => {
            this.accountsAll = data;
            this.loadingTreeOfAccounts = false;
        });
    }

    onTreeOfAccountsExpand(event) {
        const node = event.node;

        if (this.id !== 'new' && node.children === undefined) {
            this.loadingTreeOfAccounts = true;
            this.accountService.children(this.id, node.data.id).then(data => {
                node.children = [...data];
                this.accountsForFilter = [...this.accountsForFilter];
                this.loadingTreeOfAccounts = false;

            });
        }
    }

    onKeydownTreeSearch(event: KeyboardEvent) {
        if (
            event.key === 'Enter' &&
            this.searchTree.nativeElement.value === ''
        ) {
            this.accountService.getAll(this.id, []).then(data => {
                this.accountsAll = data;
                this.loadingTreeOfAccounts = false;
            });
        } else if (event.key === 'Enter') {
            this.filterTreeOfAccounts(this.searchTree.nativeElement.value);
        }
    }

    public GetImage(url) {
        var http = new XMLHttpRequest();
        http.open('GET', url, true);
        http.responseType = "blob";
        let token = localStorage.getItem('jwt');
        http.setRequestHeader('Authorization', 'Bearer ' + token);
        http.onload = this.loadImage;
        http.send();
    }

    public loadImage(e) {
        var urlCreator = window.URL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        $("#photoToUpload").attr('src', imageUrl);
    }

    public ImageExists(url) {
        var http = new XMLHttpRequest();
        http.open('GET', url, false);
        let token = localStorage.getItem('jwt');
        http.setRequestHeader('Authorization', 'Bearer ' + token);
        http.send();
        return http.status != 404;
    }

    public getLinkPicture() {
        if (this.timeStamp) {
            if (this.ImageExists(this.urlPicture + "?" + this.timeStamp)) {
                return this.urlPicture + "?" + this.timeStamp;
            } else {
                return "../assets/layout/images/report-image-placeholder.jpg";
            }
        }
        return this.urlPicture;
    }

    public setLinkPicture(url: string) {
        this.urlPicture = url;
        this.timeStamp = new Date().getTime();
    }

    onUpload(event) {
        this.setLinkPicture(this.urlPicture);
        this.messageService.add({
            severity: 'success',
            summary: 'Image successfully uploaded!'
        });
        this.ngOnInit();
        this.displayPictureChange = false;
    }

    onPictureSelect(event) {
        this.allowUpload = false;

        if (event.files[0]) {
            //check if file is larger than 0,5MB
            if (event.files[0].size / 1000000 > 0.5) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Can not upload image',
                    detail: 'Image is larger than allowed (0,5 MB)! Please choose another image.'
                });
                return;
            }
            var reader = new FileReader();

            reader.onload = function (e) {
                $('#photoToUpload').hide();
                $('#uploadedPhotoWrapper').html('<img id="photoToUpload" />');
                $('#photoToUpload')
                    .attr('src', reader.result as string)
                    .height(100)
                    .width("auto");
            };

            reader.readAsDataURL(event.files[0]);

            this.allowUpload = true;
        }
    }

    collapse() {
        if (this.accountsForFilter) {
            this.accountsForFilter.forEach(node => {
                this.expandRecursive(node, false);
            });
            this.accountsForFilter = [...this.accountsForFilter];
        }
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (!node.leaf && node.children !== null) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    expand() {
        this.accountsForFilter.forEach(node => {
            this.expandRecursive(node, true);
        });
        this.accountsForFilter = [...this.accountsForFilter];
    }

    updateLineTotaling() {
        // ukoliko je potrebno samo update-ati Totaling
        //this.lineService.updateOnlyTotaling(this.objectline.Id, this.objectline.Totaling).then(() => console.log("TEST"));
        this.saveClickLine();

    }
    updateLineTotalingRange() {
        //this.lineService.updateOnlyTotaling(this.objectline.Id, this.objectline.Totaling).then(() => console.log("TEST"));
        this.saveClickLine();
    }
    displayTableLIneF() {
        this.displayline = true;
    }

    onShow() {

        const rptLine = sessionStorage.getItem('rptLine');
        console.log("rptLine",rptLine)
        let parsedLine = null;

        if (rptLine !== "0" && rptLine !==null) {
            try {
                console.info("parsedLine");
                parsedLine = JSON.parse(rptLine);

                // Determine the correct objectline
                this.objectline = parsedLine
                this.currOperation = 'edit';
                this.displayline = true;
                // ovdje dovuci podatke
                this.lineService
                    .getAllForReport(
                        this.object.Id,
                        parsedLine.Id
                    )
                    .then(objects => {
                        this.reportLines = objects;
                    });
            } catch (e) {
                console.error("Failed to parse rptLine from sessionStorage", e);
            }

        }
    }


onRowSelected(args: any): void {
  this.closeActionMenu();
    
  this.selected = args.data;
  this.selectedRecordId = args.data.Id;
  this.highlightedRecordId = args.data.Id;
  this.pendingRestoreRecordId = null;
  this.pendingRestorePageNumber = null;
  this.pendingRestoreExpanded = false;
  this.applyHighlightedRowState();
}

onContextMenuClick(args: MenuEventArgs): void {
  this.closeActionMenu();
  const rowIndex = (args as any)?.rowInfo?.rowIndex;

  switch (args.item.id) {
    case 'expand-row':
        this.treeGridObj.expandAll();
      break;
    case 'collapse-row':
        this.treeGridObj.collapseAll();
      break;
  }
}

  public filterOptions = {
  type: 'Excel', // or 'Excel', 'FilterBar'
  mode: 'Immediate' // filters as you type
};

public filterContains = {
  operator: 'contains', // this is the LIKE '%value%'
  ignoreCase: true
};

private readonly rootParentSentinel = 999999;

private getRecordId(row: any): number | null {
  return row?.Id ?? row?.id ?? null;
}

private getParentId(row: any): number | null {
  const parentId = row?.ParentLine?.Id ?? row?.ParentLine?.id ?? null;
  return parentId === this.rootParentSentinel ? null : parentId;
}

private getParentName(row: any): string | null {
  return row?.ParentLine?.Name ?? row?.ParentLine?.name ?? null;
}

private toParentLineRef(row: any): { Id: number; Name: string } | null {
  const parentId = this.getParentId(row);
  if (parentId == null) {
    return null;
  }

  return {
    Id: parentId,
    Name: this.getParentName(row) ?? ''
  };
}

private createParentRefFromRow(row: any): { Id: number; Name: string } {
  return {
    Id: this.getRecordId(row),
    Name: `${row?.RowNo ?? ''} - ${row?.Description ?? ''}`.trim()
  };
}

private getSiblings(records: any[], parentId: number | null): any[] {
  return records
    .filter(record => this.getParentId(record) === parentId)
    .sort((a, b) => Number(a?.LineNo ?? 0) - Number(b?.LineNo ?? 0));
}

private renumberLines(records: any[]): any[] {
  records.forEach((item, index) => {
    item.LineNo = (index + 1) * 10;
  });

  return records;
}

private buildReorderPayload(records: any[]): any[] {
  return records.map(record => ({
    Id: this.getRecordId(record),
    LineNo: record.LineNo,
    ParentLine: this.toParentLineRef(record)
  }));
}

private isDropIntoOwnDescendant(draggedId: number | null, targetParentId: number | null): boolean {
  if (draggedId == null || targetParentId == null || !this.treeGridObj?.flatData) {
    return false;
  }

  const byId = new Map<number, any>();
  (this.treeGridObj.flatData as any[]).forEach(record => {
    const id = this.getRecordId(record);
    if (id != null) {
      byId.set(id, record);
    }
  });

  let currentId = targetParentId;
  while (currentId != null) {
    if (currentId === draggedId) {
      return true;
    }

    const currentRecord = byId.get(currentId);
    currentId = this.getParentId(currentRecord);
  }

  return false;
}

onRowDropOld(args: any): void {
const draggedData = args.data[0] as any;
const droppedData = args.dropIndex !== undefined
  ? this.treeGridObj.getCurrentViewRecords()[args.dropIndex] as any
  : null;


  if (!droppedData) {
    args.cancel = true;
    return;
  }

const draggedParentId = draggedData.ParentLine?.id;
const droppedParentId = droppedData?.ParentLine?.id;
console.log("draggedParentId", draggedParentId);
console.log("droppedParentId", droppedParentId);    
console.log("currentRecord");
console.log(args.data[0] );

/*PROBLEM 
IMAMO sortiranje po LineNo, ali ako se redak premjesti na drugo mjesto,
 dodjeli mu se drugi Parent tada neće biti konzistentni podaci u redosljedu jer već imamo LineNO a što onda sa PArentLine?
*/
  if (draggedParentId !== droppedParentId) {
    // Cancel the drop — different parent
    args.cancel = true;

    // Optional: show error message
    alert('You can only move rows within the same parent.');
  }
}
onRowDrop_old2(args: any): void {
  const draggedData = args.data[0];
  const dropIndex = args.dropIndex;
const droppedData = args.dropIndex !== undefined
  ? this.treeGridObj.getCurrentViewRecords()[args.dropIndex] as any
  : null;

  if (!droppedData) {
    args.cancel = true;
    return;
  }

  const draggedParentId = draggedData?.ParentLine?.id ?? null;
  const droppedParentId = droppedData?.ParentLine?.id ?? null;
  const droppedId = droppedData?.Id ?? null;

  // === CASE 1: Prevent move across top-level trees ===
  if (draggedParentId !== droppedParentId && !droppedData.hasChildRecords) {
    args.cancel = true;
    alert('You can only move rows within the same parent.');
    return;
  }

  // === CASE 2: Dropped ONTO another item (nested) ===
  const isDroppedOntoItem = args.target && args.target.classList.contains('e-rowcell');

  if (isDroppedOntoItem && droppedData && droppedData.Id !== draggedData.Id) {
    // Change the ParentLine of dragged item
    draggedData.ParentLine = {
      id: droppedData.Id,
      name: droppedData.Description
    };

    // Find children of the new parent (if any)
    const newSiblings = this.treeGridObj.getCurrentViewRecords()
      .filter((r: any) => r?.ParentLine?.id === droppedData.Id)
      .sort((a: any, b: any) => Number(a.LineOn) - Number(b.LineOn));

    // Add draggedData as last child
    const updatedList = [...newSiblings, draggedData];
    const LineOnStart = 1000;
    const LineOnStep = 100;

    updatedList.forEach((item: any, index: number) => {
      item.LineOn = (LineOnStart + LineOnStep * index).toString();
    });

    // === Call backend to update ParentId & LineOns ===
    const payload = updatedList.map((item: any) => ({
      id: item.Id,
      newLineOn: item.LineOn,
      parentId: item.ParentLine?.id ?? null
    }));

    this.lineService.reorderLineOnWithParent(payload)
      .then(() => this.treeGridObj.refresh());

    return;
  }

  // === CASE 3: Reordering within same parent ===
  const siblings = this.treeGridObj.getCurrentViewRecords()
    .filter((r: any) => (r?.ParentLine?.id ?? null) === draggedParentId)
    .sort((a: any, b: any) => Number(a.LineOn) - Number(b.LineOn));

  const newOrder = siblings.filter((r: any) => r.Id !== draggedData.Id);
  newOrder.push(draggedData); // Move dragged to end

  const LineOnStart = 1000;
  const LineOnStep = 100;

  newOrder.forEach((item: any, index: number) => {
    item.LineOn = (LineOnStart + LineOnStep * index).toString();
  });

  const reorderedList = newOrder.map((item: any) => ({
    id: item.Id,
    newLineOn: item.LineOn,
    parentId: item.ParentLine?.id ?? null
  }));

  this.lineService.reorderLineOnWithParent(reorderedList)
    .then(() => this.treeGridObj.refresh());
}

onRowDrop(args: any): void {
  this.closeActionMenu();
  args.cancel = true;
  this.loadingLines = true;

  const dragged = args?.data?.[0];
  const dropped = args?.dropIndex !== undefined
    ? this.treeGridObj.getCurrentViewRecords()[args.dropIndex] as any
    : null;
  const dropPosition = args?.dropPosition as string;

  const draggedId = this.getRecordId(dragged);
  const droppedId = this.getRecordId(dropped);

  if (!dragged || !dropped || draggedId == null || droppedId == null || draggedId === droppedId) {
    this.loadingLines = false;
    return;
  }

  if (dropPosition === 'Invalid') {
    this.loadingLines = false;
    return;
  }

  const sourceParentId = this.getParentId(dragged);

  let targetParentId: number | null;
  let newParent: { Id: number; Name: string } | null;
  let insertIndex: number;

  if (dropPosition === 'middleSegment') {
    targetParentId = droppedId;
    newParent = this.createParentRefFromRow(dropped);
  } else {
    targetParentId = this.getParentId(dropped);
    newParent = targetParentId == null ? null : this.toParentLineRef(dropped);
  }

  if (this.isDropIntoOwnDescendant(draggedId, targetParentId)) {
    this.loadingLines = false;
    this.messageService.add({
      severity: 'warn',
      summary: 'Move not allowed',
      detail: 'A row cannot be dropped into its own child hierarchy.'
    });
    return;
  }

  const flat = [...this.treeGridObj.flatData] as any[];
  const withoutDragged = flat.filter(record => this.getRecordId(record) !== draggedId);

  const targetSiblings = this.getSiblings(withoutDragged, targetParentId);
  const dropIndexInTarget = targetSiblings.findIndex(record => this.getRecordId(record) === droppedId);

  if (dropPosition === 'middleSegment') {
    insertIndex = targetSiblings.length;
  } else if (dropIndexInTarget === -1) {
    insertIndex = targetSiblings.length;
  } else if (dropPosition === 'topSegment') {
    insertIndex = dropIndexInTarget;
  } else {
    insertIndex = dropIndexInTarget + 1;
  }

  dragged.ParentLine = newParent;
  targetSiblings.splice(insertIndex, 0, dragged);

  const updatedGroups: any[][] = [];
  updatedGroups.push(this.renumberLines(targetSiblings));

  if (sourceParentId !== targetParentId) {
    const sourceSiblings = this.getSiblings(withoutDragged, sourceParentId);
    updatedGroups.push(this.renumberLines(sourceSiblings));
  }

  const payload = updatedGroups
    .flat()
    .filter((record, index, records) =>
      index === records.findIndex(candidate => this.getRecordId(candidate) === this.getRecordId(record))
    );

  this.lineService.reorderRowNos(this.buildReorderPayload(payload))
    .then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Line hierarchy updated.'
      });
      this.ngOnInit();
    })
    .catch((err: any) => {
      this.loadingLines = false;
      const extractedError = Utils.extractSQLError(err?.error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: extractedError || 'Drag and drop update failed.'
      });
      console.error(err);
    });
}


toggleDropdown(data: any, event: MouseEvent) {
  event.stopPropagation();

  const rowId = data?.Id ?? null;
  this.openActionMenuRowId = this.openActionMenuRowId === rowId ? null : rowId;
}

onRowDoubleClick(event: any): void {
  this.closeActionMenu();

  this.selected = event.rowData;
  this.selectedRecordId = event.rowData.Id;
  this.highlightedRecordId = event.rowData.Id;
  this.applyHighlightedRowState();

  const rowData = event.rowData;
  console.log('viewReportDefinitionLine:', rowData);
  this.viewReportDefinitionLine(rowData);
}

}
